import { Axios } from "../utils/axios";

// 获取列表

export const getList = params => {
  return Axios.get("/trainAdmin/questionPracticalInfo/list", { params });
};
// 新增;
export const createInfo = data => {
  console.log(data);
  return Axios.post("/trainAdmin/questionPracticalInfo", data);
};
// 编辑
export const editInfo = data => {
  console.log(data);
  return Axios.put("/trainAdmin/questionPracticalInfo", data);
};
// 删除;
export const deleteInfo = id => {
  return Axios.delete(`/trainAdmin/questionPracticalInfo/${id}`);
};
// 单条信息;
export const getInfo = id => {
  return Axios.get(`/trainAdmin/questionPracticalInfo/${id}`);
};



// WEBPACK FOOTER //
// ./src/api/handsOnBank.js